import cardStyle from "../../../../styles/CardCategory.module.css"
import React, { type ReactNode } from "react"
import GetSpace from "../../../../utils/space"
import THEME from "../../../../configuration/Theme"
import { faCalculator, faMinus, faPenNib, faPlus, faTag } from "@fortawesome/free-solid-svg-icons"
import { convertToLocalMoney } from "../../../../Objects/Generics/Helps"
import i18next from "i18next"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { CardItem } from "../../../../components/Card/CardItem"
import Animate, { AnimationTypes } from "../../../../components/Animate/Animate"
import { AwardEntity } from "../../../../Objects/Awards/AwardEntity"

interface CalculateViewProps {
  valueBaseProducts: number
  valueBaseCatalogItems: number
  valueAddtionals: number
  valueBaseSum: number
  valueTotalDiscount: number
  valueBaseSumWithDiscount: number
  valueBaseExtraServices: number
  valueTotalAwards: number
  valueTotalCoupons: number
  valueTotalShippingFee: number
  valueFinalWithoutAwards: number
  valueFinal: number
  awards?: AwardEntity[]
  children?: ReactNode
}

export const CalculateView: React.FC<CalculateViewProps> = ({
  valueBaseProducts,
  valueBaseCatalogItems,
  valueAddtionals,
  valueBaseSum,
  valueTotalDiscount,
  valueBaseSumWithDiscount,
  valueBaseExtraServices,
  valueTotalCoupons,
  valueTotalShippingFee,
  valueTotalAwards,
  valueFinal,
  awards: awardManagerEntity,
  children,
}) => {
  return (
    <>
      {valueFinal !== 0 && (
        <Animate type={AnimationTypes.fadeInTraslate} duration="1.5s">
          <div className={cardStyle.card}>
            <div className={cardStyle.cardCollum}>
              <div className={cardStyle.cardContent}>
                <div className={cardStyle.cardContent}>
                  <FontAwesomeIcon icon={faCalculator} style={{ marginLeft: "10px", fontSize: "14px" }} />

                  <span className={cardStyle.cardTitle}>{i18next.t("calculate:label_title_calculate")}</span>
                </div>
              </div>
            </div>

            <div className={cardStyle.divisionBar} style={{ margin: "10px" }}></div>

            <div className={cardStyle.cardCollum} style={{ padding: "5px 0px 0px 5px" }}>
              <CardItem
                title={i18next.t("calculate:label_total_products")}
                icon={faPlus}
                subtitle={convertToLocalMoney(valueBaseProducts)}
                txtColor={THEME.colors.iconBGAlertColor}
                iconColor={THEME.colors.iconBGAlertColor}
                borderColor={THEME.colors.white}
              />

              <GetSpace top={5} />

              <CardItem
                title={i18next.t("calculate:label_total_catalogItems")}
                icon={faPlus}
                subtitle={convertToLocalMoney(valueBaseCatalogItems)}
                txtColor={THEME.colors.iconBGAlertColor}
                iconColor={THEME.colors.iconBGAlertColor}
                borderColor={THEME.colors.white}
              />

              <GetSpace top={5} />

              <CardItem
                title={i18next.t("calculate:label_total_addtionals")}
                icon={faPlus}
                subtitle={convertToLocalMoney(valueAddtionals)}
                txtColor={THEME.colors.iconBGAlertColor}
                iconColor={THEME.colors.iconBGAlertColor}
                borderColor={THEME.colors.white}
              />

              <GetSpace top={5} />

              <CardItem
                title={i18next.t("calculate:label_total_not_liquid")}
                icon={faPenNib}
                subtitle={convertToLocalMoney(valueBaseSum)}
                iconColor={THEME.colors.black}
                borderColor={THEME.colors.white}
              />

              <GetSpace top={5} />

              <CardItem
                title={i18next.t("calculate:label_total_discount")}
                subtitle={convertToLocalMoney(valueTotalDiscount)}
                icon={faMinus}
                txtColor={THEME.colors.iconBGLessColor}
                iconColor={THEME.colors.iconBGLessColor}
                borderColor={THEME.colors.white}
              />

              {valueTotalCoupons > 0 && (
                <>
                  <GetSpace top={5} />

                  <CardItem
                    title={i18next.t("calculate:label_total_cupon")}
                    icon={faTag}
                    txtColor={THEME.colors.iconBGLessColor}
                    iconColor={THEME.colors.iconBGLessColor}
                    borderColor={THEME.colors.white}
                    subtitle={convertToLocalMoney(valueTotalCoupons)}
                  />
                </>
              )}

              <GetSpace top={5} />

              <CardItem
                title={i18next.t("calculate:label_total_with_discount")}
                icon={faPenNib}
                subtitle={convertToLocalMoney(valueBaseSumWithDiscount)}
                iconColor={THEME.colors.black}
                borderColor={THEME.colors.white}
              />

              <GetSpace top={5} />

              <CardItem
                title={i18next.t("calculate:label_total_extra")}
                icon={faPlus}
                subtitle={convertToLocalMoney(valueBaseExtraServices)}
                txtColor={THEME.colors.iconBGAlertColor}
                iconColor={THEME.colors.iconBGAlertColor}
                borderColor={THEME.colors.white}
              />

              {valueTotalAwards > 0 && (
                <>
                  {awardManagerEntity?.map((e) => {
                    return (
                      <CardItem
                        icon={faMinus}
                        txtColor={THEME.colors.iconBGLessColor}
                        iconColor={THEME.colors.iconBGLessColor}
                        borderColor={THEME.colors.white}
                        subtitle={e.getValueToString()}
                        title={e.name}
                      />
                    )
                  })}

                  <CardItem
                    title={i18next.t("calculate:label_total_awards")}
                    subtitle={convertToLocalMoney(valueTotalAwards)}
                    icon={faPenNib}
                    txtColor={THEME.colors.black}
                    iconColor={THEME.colors.black}
                    borderColor={THEME.colors.white}
                  />
                </>
              )}

              {valueTotalShippingFee > 0 && (
                <>
                  <GetSpace top={5} />

                  <CardItem
                    title={i18next.t("calculate:label_total_shipping_fee")}
                    icon={faPlus}
                    subtitle={convertToLocalMoney(valueTotalShippingFee)}
                    txtColor={THEME.colors.iconBGAlertColor}
                    iconColor={THEME.colors.iconBGAlertColor}
                    borderColor={THEME.colors.white}
                  />
                </>
              )}

              <GetSpace top={5} />

              <CardItem
                title={i18next.t("calculate:label_total_final")}
                icon={faPenNib}
                subtitle={convertToLocalMoney(valueFinal)}
                iconColor={THEME.colors.black}
                borderColor={THEME.colors.black}
              />

              {children}
            </div>
          </div>
        </Animate>
      )}
    </>
  )
}
